import React from 'react';
import './../test.css';
const runet = `${process.env.PUBLIC_URL}/Images/t.png`;
const runea = `${process.env.PUBLIC_URL}/Images/a.png`;
const runer = `${process.env.PUBLIC_URL}/Images/r.png`;
const runei = `${process.env.PUBLIC_URL}/Images/i.png`;
const LateralDefile = () => {
  return (
    <div className="">
      <div className="marquee marquee--3">
        <img src={runet} alt="Rune Apprendre" className="marquee__item" />
        <img src={runea} alt="Rune Apprendre" className="marquee__item" />
        <img src={runer} alt="Rune Apprendre" className="marquee__item" />
        <img src={runei} alt="Rune Apprendre" className="marquee__item" />
        <img src={runea} alt="Rune Apprendre" className="marquee__item" />
        <img src={runet} alt="Rune Apprendre" className="marquee__item" />
        <img src={runea} alt="Rune Apprendre" className="marquee__item" />
        <img src={runer} alt="Rune Apprendre" className="marquee__item" />
        <img src={runei} alt="Rune Apprendre" className="marquee__item" />
        <img src={runea} alt="Rune Apprendre" className="marquee__item" />
        <img src={runet} alt="Rune Apprendre" className="marquee__item" />
        <img src={runea} alt="Rune Apprendre" className="marquee__item" />
        <img src={runer} alt="Rune Apprendre" className="marquee__item" />
        <img src={runei} alt="Rune Apprendre" className="marquee__item" />
        <img src={runea} alt="Rune Apprendre" className="marquee__item" />
      </div>
      <div className="marqueeG marquee--3">
        <img src={runet} alt="Rune Apprendre" className="marquee__itemG" />
        <img src={runea} alt="Rune Apprendre" className="marquee__itemG" />
        <img src={runer} alt="Rune Apprendre" className="marquee__itemG" />
        <img src={runei} alt="Rune Apprendre" className="marquee__itemG" />
        <img src={runea} alt="Rune Apprendre" className="marquee__itemG" />
        <img src={runet} alt="Rune Apprendre" className="marquee__itemG" />
        <img src={runea} alt="Rune Apprendre" className="marquee__itemG" />
        <img src={runer} alt="Rune Apprendre" className="marquee__itemG" />
        <img src={runei} alt="Rune Apprendre" className="marquee__itemG" />
        <img src={runea} alt="Rune Apprendre" className="marquee__itemG" />
        <img src={runet} alt="Rune Apprendre" className="marquee__itemG" />
        <img src={runea} alt="Rune Apprendre" className="marquee__itemG" />
        <img src={runer} alt="Rune Apprendre" className="marquee__itemG" />
        <img src={runei} alt="Rune Apprendre" className="marquee__itemG" />
        <img src={runea} alt="Rune Apprendre" className="marquee__itemG" />
      </div>
    </div>
  );
};
export default LateralDefile;
